import { render } from "./Login.vue?vue&type=template&id=bff494c6&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=bff494c6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/projeto_logistica/projeto_logistica/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bff494c6"],['__file',"src/views/Account/Login.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bff494c6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bff494c6', __exports__)) {
    console.log('reload')
    api.reload('bff494c6', __exports__)
  }
  
  module.hot.accept("./Login.vue?vue&type=template&id=bff494c6&scoped=true", () => {
    console.log('re-render')
    api.rerender('bff494c6', render)
  })

}


export default __exports__